import React from 'react';

const DEFAULT_SHELTER_ICON = (React.createElement("svg", { width: "24px", height: "24px", viewBox: "0 0 24 24", version: "1.1", xmlns: "http://www.w3.org/2000/svg" },
    React.createElement("g", { id: "\u89C6\u89C9", stroke: "none", strokeWidth: "1", fill: "none", fillRule: "evenodd" },
        React.createElement("g", { id: "03_\u8BC4\u8BBA_\u8BC4\u8BBA\u5F52\u6863", transform: "translate(-243.000000, -195.000000)" },
            React.createElement("g", { id: "\u7F16\u7EC4", transform: "translate(243.000000, 195.000000)" },
                React.createElement("rect", { id: "bg", x: "0", y: "0", width: "24", height: "24", rx: "2" }),
                React.createElement("path", { d: "M7,11 L7,13 L5,13 L5,11 L7,11 Z M13,11 L13,13 L11,13 L11,11 L13,11 Z M19,11 L19,13 L17,13 L17,11 L19,11 Z", id: "\u5F62\u72B6\u7ED3\u5408", fill: "#464D5A", fillRule: "nonzero" }))))));

export { DEFAULT_SHELTER_ICON };
//# sourceMappingURL=default-shelter-icon.js.map
